import logo from './logo.svg';
import './App.css';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Education from './components/Education/Education';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Activities from './components/Skills/Activities';

function App() {
  return (
    <div className="App">
      <Header/>
      <Home/>
      <Education/>
      <Projects/>
      <Activities/>
      <Contact/>

      
    </div>
  );
}

export default App;
